import {getField, updateField} from 'vuex-map-fields'

// I still don't know why we don't have the $http plugin in the store
import { Api } from '../plugins/axios'

let filters = {
    lead_source_ids: null,
    source: null,
    pipeline_groups : null,
    tags_included: [],
    tags_excluded: [],
    only_verified: false,
    include_hidden: false,
    sort: 'assigned_date DESC',
    lead_pool_id: null,
    agent: null,
    assigned_agents: [],
    price_range_from : null,
    price_range_to : null,
    home_value_min : null,
    home_value_max : null,
    count_calls_min : null,
    count_calls_max : null,
    called_by : null,
    created : null,
    last_called : null,
    never_called : false,
    cities : null,
    states : null,
    zips : null,
    type : 'BS',
    origin : [],
    term: '',
    data_augmented : null,
    met_face_to_face: null,
    team_id : null,
    worked : null
}

let tempFilters = {
    source: null,
    pipeline_groups : null,
    tags_included: [],
    tags_excluded: [],
    only_verified: false,
    include_hidden: false,
    sort: 'assigned_date DESC',
    lead_pool_id: null,
    agent: null,
    assigned_agents: [],
    price_range_from : null,
    price_range_to : null,
    home_value_min : null,
    home_value_max : null,
    count_calls_min : null,
    count_calls_max : null,
    called_by : null,
    created : null,
    last_called : null,
    never_called : false,
    cities : null,
    states : null,
    zips : null,
    type : 'BS',
    origin : [],
    term: '',
    data_augmented : null,
    met_face_to_face: null,
    team : null,
    worked : null
}

let tempFilterShow = -1;

export const state = () => ({
    filters: filters,
    tempFilters: tempFilters,
    tempFilterShow: tempFilterShow,
    showFilters: false,
    lead: {
        id: null,
        team_id: null,
        worked: null
    },
    selectedLeadIds : [],
    selectAll: [],
    duplicates : 0,
    storedActivePipeline : null,
    userInitiatedChangesCount: 0,
    showUserChangesPopup: false,
    fieldChangedFlag: {},
})

export const actions = {
    async loadLead(context, leadId){
        let { data : { lead } } = await Api.get('/api/v1/client-leads/get-lead-by-id/' + leadId)
        context.commit('updateLead', lead)
    }
}

export const getters = {
    getField,
}

export const mutations = {
    updateField,
    resetFilter(state) {
        state.filters = filters
        state.tempFilters = tempFilters
        state.tempFilterShow = -1
        state.selectedLeadIds = []
    },
    toggleFilter(state) {
        state.showFilters = !state.showFilters
    },
    updateLead(state, lead) {
        state.lead = lead
    },
    incrementUserInitiatedChanges(state) {
        state.userInitiatedChangesCount++;
        state.showUserChangesPopup = true;
      },
    resetUserInitiatedChanges(state) {
        state.userInitiatedChangesCount = 0;
        state.showUserChangesPopup = false;
        state.fieldChangedFlag = {};
    },
    decreaseUserInitiatedChanges(state) {
        if (state.userInitiatedChangesCount > 0) {
            state.userInitiatedChangesCount--;
        }
        if (state.userInitiatedChangesCount === 0) {
            state.showUserChangesPopup = false;
        }
    },
    resetLead(state) {
        state.lead = { id: null, team_id: null, worked: null };
        state.duplicates = 0;
        state.userInitiatedChangesCount = 0;
        state.showUserChangesPopup = false;
        state.fieldChangedFlag = {};
    }
}
